<template>
  <transition name="fade">
    <div v-if="show" class="business-root">
      <div class="bgs">
        <div :style="bg3Style" class="bg bg3"></div>
        <div :style="bg4Style" class="bg bg4"></div>
      </div>

      <ul class="texts">
        <li class="text text1">
          <dl>
            <dt :style="text1IndexStyle" class="index">
              <blur-image
                width="58"
                height="36"
                url="/images/business-index-1.svg"
              ></blur-image>
            </dt>
            <dd class="content">
              <span :style="text11ContentStyle" class="text1-1">
                <blur-image
                  width="55"
                  height="32"
                  url="/images/business/text1-1@2x.png"
                ></blur-image>
              </span>
              <span :style="text12ContentStyle" class="text1-2">
                <blur-image
                  width="102"
                  height="32"
                  url="/images/business/text1-2@2x.png"
                  :px="blurPixel"
                ></blur-image>
              </span>
            </dd>
          </dl>
        </li>

        <li class="text text2">
          <dl>
            <dt :style="text2IndexStyle" class="index">
              <blur-image
                width="58"
                height="36"
                url="/images/business-index-2.svg"
              ></blur-image>
            </dt>
            <dd class="content">
              <span :style="text21ContentStyle">
                <blur-image
                  width="55"
                  height="32"
                  url="/images/business/text2-1@2x.png"
                ></blur-image>
              </span>
              <span :style="text22ContentStyle">
                <blur-image
                  width="104"
                  height="32"
                  url="/images/business/text2-2@2x.png"
                  :px="blurPixel"
                ></blur-image>
              </span>
              <span :style="text23ContentStyle">
                <blur-image
                  width="135"
                  height="32"
                  url="/images/business/text2-3@2x.png"
                ></blur-image>
              </span>
            </dd>
          </dl>
        </li>

        <li class="text text3">
          <dl>
            <dt :style="text3IndexStyle" class="index">
              <blur-image
                width="58"
                height="36"
                url="/images/business-index-3.svg"
              ></blur-image>
            </dt>
            <dd class="content">
              <span :style="text3ContentStyle">
                <blur-image
                  width="244"
                  height="32"
                  url="/images/business/text3-1@2x.png"
                  :px="blurPixel"
                ></blur-image>
              </span>

              <span :style="text23ContentStyle">
                <blur-image
                  width="86"
                  height="32"
                  url="/images/business/text3-2@2x.png"
                ></blur-image>
              </span>
            </dd>
          </dl>
        </li>

        <li class="text text4">
          <dl>
            <dt :style="text4IndexStyle" class="index">
              <blur-image
                width="58"
                height="36"
                url="/images/business-index-4.svg"
              ></blur-image>
            </dt>
            <dd class="content">
              <span :style="text41ContentStyle">
                <blur-image
                  width="101"
                  height="32"
                  url="/images/business/text4-1@2x.png"
                ></blur-image>
              </span>
              <span :style="text42ContentStyle">
                <blur-image
                  width="72"
                  height="32"
                  url="/images/business/text4-2@2x.png"
                  :px="blurPixel"
                ></blur-image>
              </span>
              <span :style="text43ContentStyle">
                <blur-image
                  width="134"
                  height="32"
                  url="/images/business/text4-3@2x.png"
                ></blur-image>
              </span>
            </dd>
          </dl>
        </li>

        <li class="text text5">
          <dl>
            <dt :style="text5IndexStyle" class="index">
              <blur-image
                width="58"
                height="36"
                url="/images/business-index-5.svg"
              ></blur-image>
            </dt>
            <dd class="content">
              <span :style="text51ContentStyle">
                <blur-image
                  width="91"
                  height="32"
                  url="/images/business/text5-1@2x.png"
                  :px="blurPixel"
                ></blur-image>
              </span>
              <span :style="text52ContentStyle">
                <blur-image
                  width="214"
                  height="32"
                  url="/images/business/text5-2@2x.png"
                ></blur-image>
              </span>
            </dd>
          </dl>
        </li>
      </ul>
    </div>
  </transition>
</template>

<script>
import { fadeStyle, transformStyle, blurPixel } from '../../lib/styleGenerator'

export default {
  name: 'pageConcept',

  computed: {
    blurPixel() {
      return blurPixel(this.scrollRate)
    },
    show() {
      const currentPage = this.$store.getters.currentPage

      return currentPage === 'business'
    },
    scrollRate() {
      return this.$store.getters.businessPageRate
    },
    text1IndexStyle() {
      return {
        ...transformStyle(this.scrollRate, { scale: 2, x: -20 }),
        ...fadeStyle(this.scrollRate, 5, 0.4)
      }
    },
    text11ContentStyle() {
      return {
        ...transformStyle(this.scrollRate, { x: 20 })
      }
    },
    text12ContentStyle() {
      return {
        ...transformStyle(this.scrollRate, { x: 50, scale: 1.8 }),
        ...fadeStyle(this.scrollRate)
      }
    },
    text2IndexStyle() {
      return {
        ...transformStyle(this.scrollRate, { y: 50 })
      }
    },
    text21ContentStyle() {
      return {
        ...transformStyle(this.scrollRate, { y: 80 })
      }
    },
    text22ContentStyle() {
      return {
        ...transformStyle(this.scrollRate, { x: 50, scale: 1.8 }),
        ...fadeStyle(this.scrollRate)
      }
    },
    text23ContentStyle() {
      return {
        ...transformStyle(this.scrollRate, { y: 80 })
      }
    },
    text3IndexStyle() {
      return {
        ...transformStyle(this.scrollRate, { y: 50 })
      }
    },
    text3ContentStyle() {
      return {
        ...transformStyle(this.scrollRate, { x: -40, scale: 1.3 }),
        ...fadeStyle(this.scrollRate, 1)
      }
    },
    text4IndexStyle() {
      return {
        ...transformStyle(this.scrollRate, { x: -150, scale: 1.5 }),
        ...fadeStyle(this.scrollRate, 3)
      }
    },
    text41ContentStyle() {
      return {
        ...transformStyle(this.scrollRate, { x: 20 })
      }
    },
    text42ContentStyle() {
      return {
        ...transformStyle(this.scrollRate, { x: 70, scale: 1.3 }),
        ...fadeStyle(this.scrollRate, 1)
      }
    },
    text43ContentStyle() {
      return {
        ...transformStyle(this.scrollRate, { x: 120 })
      }
    },
    text5IndexStyle() {
      return {
        ...transformStyle(this.scrollRate, { y: 50 })
      }
    },
    text51ContentStyle() {
      return {
        ...transformStyle(this.scrollRate, { y: -50, x: -50, scale: 2 }),
        ...fadeStyle(this.scrollRate, 1)
      }
    },
    text52ContentStyle() {
      return {
        ...transformStyle(this.scrollRate, { x: 50, y: -50 })
      }
    },
    bg3Style() {
      return {
        ...transformStyle(this.scrollRate, { x: 200 })
      }
    },
    bg4Style() {
      return {
        ...transformStyle(this.scrollRate, { y: -200 })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.business-root
  position: relative

.texts
  position: absolute
  width: 458px
  height: 360px
  top: 130px
  left: 160px
  .text
    list-style: none
    margin-bottom: 40px

    @each $index in 1,2,3,4,5
      &.text#{$index}
        margin-left: -20px * ($index - 1)

    dl
      position: relative
      padding-left: 60px
    dt, dd
      display: inline-block
      font-weight: bold
    dt
      position: absolute
      top: -30px
      left: -30px
      font-size: 30px
      width: 120px
      height: 72px
      background-repeat: no-repeat
      background-size: contain
      display: flex
      justify-content: center
      align-items: center
    dd
      margin-left: 10px
      font-size: 15px
      line-height: 36px
      vertical-align: middle
      span
        display: inline-block

.bg
  position: absolute
  background-size: cover
  width: 510px
  height: 340px
  &3
    right: 130px
    top: 330px
    background-image: url('/images/bg/bg3.jpg')
  &4
    right: 222px
    top: 127px
    background-image: url('/images/bg/bg4.jpg')
</style>
